/* @jsx h */
import { defineComponent, h } from "vue";
import { LemmonModal } from "@lemmonhq/uikit";
import { CustomerCheckout, GroupOrder } from "@lemmonhq/types";
import { GroupMember } from "../../../providers/Menu/realtime/index";
import { PendingCheckoutsList } from "./PendingCheckoutsList";
import { useLocalization } from "@lemmonhq/uikit";

export interface ConfirmFinalizationModalProps {
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  groupMembers: GroupMember[];
  submittedCheckouts: GroupOrder["checkouts"];
}

export const ConfirmFinalizationModal =
  defineComponent<ConfirmFinalizationModalProps>({
    name: "ConfirmFinalizationModal",
    props: [
      "onClose",
      "onConfirm",
      "isLoading",
      "groupMembers",
      "submittedCheckouts",
    ],
    setup(props) {
      const { t } = useLocalization();
      return () => (
        <LemmonModal
          title={t("customer.checkout_status.finalize_without_friends")}
          onClose={props.onClose}
          renderButtons={() => (
            <div class="flex gap-2 p-2">
              <button
                onClick={props.onClose}
                class="btn btn-secondary flex-1"
                disabled={props.isLoading}
              >
                {t("customer.checkout_status.cancel")}
              </button>
              <button
                onClick={props.onConfirm}
                class="btn btn-primary flex-1"
                disabled={props.isLoading}
              >
                {props.isLoading ? (
                  <>
                    <span class="loading loading-spinner loading-sm"></span>
                    {t("customer.checkout_status.processing")}
                  </>
                ) : (
                  t("customer.checkout_status.confirm_send")
                )}
              </button>
            </div>
          )}
        >
          <div class="space-y-6 p-6">
            <div class="max-h-96 overflow-y-auto">
              <PendingCheckoutsList />
            </div>
          </div>
        </LemmonModal>
      );
    },
  });
